import { type ReactElement } from 'react'
import { Size } from '@front/model'
import styles from './table.module.css'

export const TableMessage = ({ span, message }: { span: number; message: string }): ReactElement => {
  return (
    <div
      className={styles.tableState}
      style={{
        gridColumn: `span ${span}`,
        padding: Size.space['4xl'],
      }}
    >
      <span className={styles.tableStateText}>{message}</span>
    </div>
  )
}
